export default {
    colors: {
        primary: '#C21B17',
        secondary: '#AA1B17'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.secondary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/generaliTheme.js